import * as z from 'zod';

import { PayStationPaymentType } from 'src/features/payment/utils/types';
import { LOCALE } from 'src/providers/types';
import { CURRENCY } from 'src/types';

export type PayStationFormSchemaValues = z.infer<typeof payStationFormSchema>;

const nominalValueSchema = z.object({
    currency: z.enum(CURRENCY),
    value: z.string(),
    enable: z.boolean(),
});
export const payStationFormSchema = z.object({
    name: z.string().nonempty(),
    code: z.string().nonempty(),
    site: z.string(),
    settings: z.object({
        enabled_payment_methods: z.array(z.enum(PayStationPaymentType)).nonempty(),
        password: z.string().nonempty(),
        languages: z.array(z.enum(LOCALE)).nonempty(),
        currencies: z.array(z.enum(CURRENCY)).nonempty(),
        lost_ticket: z.boolean(),
        web_id: z.string().nullish(),
        home_qr_value: z.string().nullish(),
        support_phone: z.string().nullish(),
        enable_free_stay: z.boolean(),
        default_language: z.enum(LOCALE),
        enable_subscriptions: z.boolean(),
        enable_settings_enter: z.boolean(),
        home_pay_button_text: z
            .object({
                bg: z.string().nullish(),
                en: z.string().nullish(),
            })
            .nullish(),
        coin_selector: z.object({
            accepted_nominals: z.array(nominalValueSchema),
            payout_nominals: z.array(nominalValueSchema),
        }),
        banknote_validator: z.object({
            accepted_nominals: z.array(nominalValueSchema),
            payout_nominals: z.array(nominalValueSchema),
        }),
    }),
});
